
// M012 service teaser
function initServiceTeaser() {

    if ($(".serviceTeaser").length > 0) {
        $(".serviceTeaser").each(function () {

            $(this).find(".serviceTeaser__teaser").each(function(){
                $(this).mouseover(function(){
                    $(this).find(".serviceTeaser__icon-image").removeClass("hovered");
                    $(this).find(".serviceTeaser__icon-image").addClass("hovered");
                });
                $(this).mouseout(function(){
                    $(this).find(".serviceTeaser__icon-image").removeClass("hovered");
                });
            });
        });
    }
}
function updateServiceTeaser() {

    if ($(".serviceTeaser").length > 0) {
        $(".serviceTeaser").each(function () {

            var hh = 0;

            $(this).find(".serviceTeaser__text").children(".serviceTeaser__headline").css("height", "auto");

            //headlines
            $(this).find(".serviceTeaser__text").each(function () {
                if ($(this).children(".serviceTeaser__headline").height() > hh) {
                    hh = Math.ceil($(this).children(".serviceTeaser__headline").height());
                }
                ;
            });
            if (hh > 0) {
                $(this).find(".serviceTeaser__text").children(".serviceTeaser__headline").css("height", hh + "px");
            }
        });
    }
}